var map = {
	"./IMG-20241025-WA0026.jpg": 2028,
	"./IMG-20241025-WA0048.jpg": 8836,
	"./our moments mweadi   9 (1).jpg": 788,
	"./our moments mweadi   9 (2).jpg": 8029,
	"./our moments mweadi   9 (3).jpg": 5250,
	"./our moments mweadi   9 (4).jpg": 1811,
	"./our moments mweadi   9 (5).jpg": 8848,
	"./our moments mweadi  (1).png": 8269,
	"./our moments mweadi  (2).png": 6544,
	"./our moments mweadi  (3).png": 1415,
	"./our moments mweadi  (4).png": 90,
	"./our moments mweadi  (5).png": 3601,
	"./our moments mweadi  (6).png": 6468,
	"./our moments mweadi  (7).png": 6059,
	"./our moments mweadi  (8).png": 7838,
	"./our moments mweadi  (9).png": 6261
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9164;